import cn from 'clsx';
import { FC, HTMLAttributes } from 'react';

import s from './Chip.module.scss';

export interface IChipProps {
  selected?: boolean;
  id?: HTMLAttributes<HTMLButtonElement>['id'];
  onClick?: HTMLAttributes<HTMLButtonElement>['onClick'];
}

const Chip: FC<React.PropsWithChildren<React.PropsWithChildren<IChipProps>>> = ({ selected = false, id = '', onClick = undefined, children = '' }) => {
  return (
    <span className={cn(s.chip, selected ? s.selected : s.unselected)} onClick={onClick}>
      <button id={id} type="button">
        {children}
      </button>
    </span>
  );
};

export default Chip;
